import React, { SVGProps } from 'react';

const HoldingsWithdrawIcon = ({
  className,
  style,
  width,
  height,
  fill,
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width || '20'}
    height={height || '20'}
    fill={fill || 'none'}
    className={className}
    style={style}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_740_1409)">
      <path
        d="M9.99935 18.3333C5.39685 18.3333 1.66602 14.6025 1.66602 10C1.66602 5.3975 5.39685 1.66667 9.99935 1.66667C11.2932 1.66569 12.5695 1.96648 13.7268 2.54512C14.8841 3.12376 15.8905 3.96431 16.666 5H14.4077C13.4454 4.15147 12.2587 3.59863 10.9899 3.40783C9.72123 3.21703 8.4244 3.39638 7.25509 3.92434C6.08577 4.45231 5.09364 5.30647 4.39774 6.38432C3.70184 7.46218 3.33174 8.71794 3.33185 10.0009C3.33195 11.2839 3.70226 12.5396 4.39834 13.6173C5.09442 14.6951 6.0867 15.5491 7.2561 16.0768C8.42551 16.6046 9.72236 16.7837 10.991 16.5927C12.2597 16.4017 13.4464 15.8487 14.4085 15H16.6669C15.8912 16.0358 14.8847 16.8764 13.7273 17.4551C12.5698 18.0337 11.2934 18.3344 9.99935 18.3333ZM15.8327 13.3333V10.8333H9.16602V9.16667H15.8327V6.66667L19.9994 10L15.8327 13.3333Z"
        fill="var(--primaryTheme)"
        stroke="#191A1F"
        strokeWidth="0"
      />
    </g>
    <defs>
      <clipPath id="clip0_740_1409">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default HoldingsWithdrawIcon;
